import { Dayjs } from 'dayjs';
export { generateLessonDates } from './generateLessonDates';

/**
 * Convierte una fecha (Dayjs) al ID de día usado en el calendario
 * @param date - Fecha a convertir
 * @returns ID de día ("Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do")
 */
export function getDayIdByDate(date: Dayjs): string {
  const dayMap = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'];
  return dayMap[date.day()];
}
